module.exports = __webpack_public_path__ + "ui-icons_ef8c08_256x240.png";


//////////////////
// WEBPACK FOOTER
// ./ui/src/vendor/jquery-ui/css/ui-lightness/images/ui-icons_ef8c08_256x240.png
// module id = 811
// module chunks = 1